module.exports = __webpack_public_path__ + "assets/img/logo.bd77b63a.png";